export { default as UiPricingComparisonTable } from "./UiPricingComparisonTable";
